import { Box } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import TextContent from './TextContent';
import ResponsiveSplitSection from '../common/ResponsiveSplitSection';
import { AboutSustainabilityQualityContent } from '../../graphql/pimcore/modules/siteContent/types/AboutSustainabilityContent';
import SustainabilityContainer from './SustainabilityContainer';
import QualityTab from './QualityTab';

interface QualityPageProps {
    cmsContent: AboutSustainabilityQualityContent;
}

const QualityPage: FunctionComponent<QualityPageProps> = ({ cmsContent }) => {
    const textContent = (
        <Box sx={{ marginTop: '1rem' }}>
            <TextContent
                name={'supply-chain'}
                content1={<div dangerouslySetInnerHTML={{ __html: cmsContent.mainText.content }} />}
            />
        </Box>
    );
    return (
        <>
            <ResponsiveSplitSection
                textContent={textContent}
                backgroundColor={'white'}
                smallScreenTextFirst={false}
                imageSrc={cmsContent.mainImage.imageUrl}
                bigScreenAlignItem="flex-start"
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F8F8F8',
                }}
            >
                <SustainabilityContainer backgroundColor={'#F8F8F8'}>
                    <QualityTab cmsContent={cmsContent} />
                </SustainabilityContainer>
            </Box>
        </>
    );
};

export default QualityPage;
